import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getCampaigns({ commit }, payload = {
        paginate: '',
        query: ''
    }) {
        const { paginate, query } = payload

        return axios
            .get(`/jmd-campaign/campaigns${paginate}${query}`)
            .then(response => {

                commit('GET_CAMPAIGNS_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_CAMPAIGNS_FAILURE')
                handleApiError(error, 'Pobranie listy kampanii nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getCampaign(_, id) {
        return axios
            .get(`/jmd-campaign/campaigns/${id}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, `Pobranie danych kampanii o id ${id} nie powiodło się.`)

                return Promise.reject(error)
            })
    },
    getCampaignStatuses({ commit }) {
        return axios
            .get('/jmd-campaign/campaign-statuses')
            .then(response => {
                commit('GET_STATUSES_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie statusów kampanii nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createCampaignByFile(_, payload) {
        return axios
            .post('/jmd-campaign/campaigns', payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Tworzenie kampanii nie powiodło się.')

                return Promise.reject(error)
            })
    },
    deleteCampaign({ commit }, id) {
        return axios
            .delete(`/jmd-campaign/campaigns/${id}`)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Kampania została usunięta.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie kampanii nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateCampaign(_, payload) {
        return axios
            .patch(`/jmd-campaign/campaigns/${payload.id}`, payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja kampanii nie powiodła się.')

                return Promise.reject(error)
            })
    },
    deleteCampaignProduct(_, id) {
        return axios
            .delete(`/jmd-campaign/campaign-products/${id}`)
            .then(response => {

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie produktu kampanii nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createCampaignProduct(_, payload) {
        return axios
            .post('/jmd-campaign/campaign-products', payload)
            .then(response => {

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie produktu kampanii nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateCampaignProduct(_, productData) {
        return axios
            .patch(`/jmd-campaign/campaign-products/${productData.id}`, productData)
            .then(response => {

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja produktu nie powiodła się.')

                return Promise.reject(error)
            })
    },
    removeCampaignProductFromJob(_, payload) {
        return axios
            .post('/jmd-campaign/remove-product-from-job', payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie produktu ze zlecenia nie powiodło się.')

                return Promise.reject(error)
            })
    },
    addProductFile(_, payload) {
        return axios
            .post('/jmd-campaign/campaign-product-files', payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie pliku nie powiodło się.')

                return Promise.reject(error)
            })
    },
    deleteProductFile(_, id) {
        return axios
            .delete(`/jmd-campaign/campaign-product-files/${id}`)
            .then(response => {

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie pliku produktu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    acceptProductFile({ commit }, file) {
        return axios
            .patch(`/jmd-campaign/campaign-product-files/${file.id}`, file)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Plik produktu został zaakceptowany.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Akceptacja pliku produktu nie powiodła się.')

                return Promise.reject(error)
            })
    },
    createCampaignSet(_, payload) {
        return axios
            .post('/jmd-campaign/campaign-product-sets', payload)
            .then(response => {

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie zestawu kampanii nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateCampaignSet(_, setData) {
        return axios
            .patch(`/jmd-campaign/campaign-product-sets/${setData.id}`, setData)
            .then(response => {

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja zestawu kampanii nie powiodła się.')

                return Promise.reject(error)
            })
    },
    deleteCampaignSet(_, id) {
        return axios
            .delete(`/jmd-campaign/campaign-product-sets/${id}`)
            .then(response => {

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie zestawu kampanii nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createCampaignDistributionCenter(_, payload) {
        return axios
            .post('/jmd-campaign/campaign-distribution-centers', payload)
            .then(response => {

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie centrum dystrybucji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateCampaignDistributionCenter(_, distributionCenterData) {
        return axios
            .patch(`/jmd-campaign/campaign-distribution-centers/${distributionCenterData.id}`, distributionCenterData)
            .then(response => {

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja centrum dystrybucji nie powiodła się.')

                return Promise.reject(error)
            })
    },
    deleteCampaignDistributionCenter(_, id) {
        return axios
            .delete(`/jmd-campaign/campaign-distribution-centers/${id}`)
            .then(response => {

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie centrum dystrybucji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getCampaignDistributionCenter(_, id) {
        return axios
            .get(`/jmd-campaign/campaign-distribution-centers/${id}`)
            .then(response => {

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie centrów dystrybucji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getProductTemplates({ commit }) {
        return axios
            .get('/product-templates/product-templates?tag=JMD')
            .then(response => {
                commit('GET_PRODUCT_TEMPLATES_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie szablonów produktów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createOrderByProduct({ commit }, payload) {
        return axios
            .post('/jmd-campaign/create-orders', payload)
            .then(response => {

                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zamówienie zostało utworzone.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Utworzenie zamówienia nie powiodło się.')

                return Promise.reject(error)
            })
    },
    generateCampaignReport({ commit }, payload) {
        return axios
            .post('/jmd-campaign/campaign-report', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: `Raport zostanie wygenerowany i przesłany na adres ${payload.userEmail}.`
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    generateProductSetReport({ commit }, payload) {
        return axios
            .post('/jmd-campaign/product-set-report', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: `Raport zostanie wygenerowany i przesłany na adres ${payload.userEmail}.`
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    generateCampaignLabelsReport({ commit }, payload) {
        return axios
            .post('/jmd-campaign/campaign-labels-report', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: `Raport zostanie wygenerowany i przesłany na adres ${payload.userEmail}.`
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    findCampaign(context, {number}) {
        return axios
            .get(`/jmd-campaign/campaigns?number=${number}&limit=10`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Szukanie kampanii nie powiodło się.')

                return Promise.reject(error)
            })
    },
    findLastClosedCampaign() {
        return axios
            .get('/jmd-campaign/campaigns?ordering=-closedAt&status_id=30&limit=1')
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie ostatniej zamkniętej kampanii nie powiodło się.')

                return Promise.reject(error)
            })
    },
    campaignsForShippingLabel(_, payload = {
        paginate: '',
        query: ''
    }) {
        const { paginate, query } = payload

        return axios
            .get(`/jmd-campaign/campaigns-for-shipping-label${paginate}${query}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie kampanii nie powiodło się.')

                return Promise.reject(error)
            })
    },
    joinOrderToCampaign({ commit }, payload) {
        return axios
            .post('/jmd-campaign/join-order-to-campaign', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zamówienie zostało przypisane do kampanii.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Przypisanie zamówienia do kampanii nie powiodło się.')

                return Promise.reject(error)
            })
    },
}
